<template>
  <section class="shoppingMall">
    <!--上新专区-->
    <header-com isTransparent/>
    <section class="newProWrap">

      <img @click="$showRulePopup" class="changeBagTop" src="/images/home/changeBag_top.png" alt="">

      <van-list
        :finished="isFinished"
        finished-text=" "
        v-if="changeBagList.length>0"
        :offset="100"
        :immediate-check="false"
        @load="getChangeProList"
      >
        <ul class="proList p40">
          <li v-for="(item,index) in changeBagList" :key="index">
            <pro-info-card :item="item"/>
          </li>
        </ul>
      </van-list>

    
    </section>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import homeApi from "@api/home";
import CollectCom from "../../../components/collectCom";
import { Toast } from "vant";
export default {
  name: "index",
  components: { CollectCom },
  data() {
    // const _this = this
    return {
      isFinished:false,
      pageNum:1,
      timeObjIndex: 1,
      timeObj: [
        { time: "10:00", isActive: true },
        { time: "12:00", isActive: true },
        { time: "14:00", isActive: true },
        { time: "16:00", isActive: true },
        { time: "18:00", isActive: true },
        { time: "20:00", isActive: false },
        { time: "22:00", isActive: false },
        { time: "24:00", isActive: false }
      ],
      swiperOption: {
        loop: true,
        spaceBetween: 6,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination"
          // type: 'progressbar',
        },
        on: {
          tap: () => {
            const item = this.bannerList[this.mySwiper.realIndex];
            // console.log(realIndex)
            this.$router.push({
              name: item.pathName,
              params: { id: item.params }
            });
          }
        }
      },
      bannerList: [
        { pathName: "sceneDetailProcess", bannerPic: "banner_01.png" },
        { pathName: "sceneDetail", bannerPic: "newbanner02.jpg", params: 1 },
        { pathName: "sceneDetail", bannerPic: "newbanner03.jpg", params: 2 }
      ],

      //上新专区时间
      timeViewOption: {
        slidesPerView: "auto",
        spaceBetween: 20,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20
      },
      //最新商品列表
      changeBagList: []
    };
  },
  computed: {
    ...mapState({
      // categoryList:state => state.attributes.categoryList,
      saleTypeObj: "saleTypeObj",
      serviceObj: "serviceObj"
    }),
    mySwiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    //诸葛：首页-进入二级页面
    zhuge.track("首页-进入二级页面", { 
          "二级页面名称":"换背专区",
          "二级页面导航名称":location.href
        });
    this.getChangeProList();
  },
  mounted() {
    
  },
  methods: {
    ...mapActions({
      addViewHistory: "user/addViewHistory"
    }),
    //获取换背商品列表
    getChangeProList() {
      let changeBagList=this.changeBagList
      this.isFinished=true
      this.getProList({
        saleType:"1",
        pageNum:this.pageNum,
        pageSize: 10
      }).then(res => {
        this.changeBagList = changeBagList.concat(res.result);
        if(res.result.length!=0){
          this.isFinished=false
          this.pageNum++
        }
        
      });
    },
    //获取商品列表
    async getProList(params = {}) {
      const { result, total } = await homeApi.getProList(params);
      return { result, total };
    },
    
    toggleCollect($event, item) {
      item.isCollect = $event;
    }
  }
};
</script>

<style lang="scss" scoped>
.shoppingMall {
  padding: 0 0 170px;

  /*最新上架*/
  .newProWrap {
    .changeBagTop{
      width: 100%;
    }

    .proList {
      padding-top: 48px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 308px;
        position: relative;
      }
    }

    
    .newProWrapSwiper {
      margin: 0 auto;
      overflow: hidden;
      box-sizing: border-box;
      width: 750px;
      padding: 48px 13px;
    }
    .slideItem {
      position: relative;
      width: 308px;
      margin: 20px 27px;
      box-shadow: $base-shadow;
      border-radius: $base-radius;
      overflow: hidden;
      float: left;

      .changeTag {
        position: absolute;
        left: 20px;
        top: 0;
      }
      .imgWrap {
        height: 217px;
        background: $white-color;
        img {
          width: 218px;
          height: 217px;
        }
      }
      .botWrap {
        padding: 15px 24px 20px;
        background: #fafafa;
        p {
          line-height: 34px;
        }
        div {
          padding-top: 10px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.shoppingMall {
  .swiper-pagination-bullet {
    width: 16px;
    height: 12px;
    background: rgba($white-color, 0.6);
    border-radius: 6px;
    transition: 0.3s;
  }
  .swiper-pagination-bullet-active {
    width: 40px;
    background: rgba($white-color, 0.6);
  }
}
</style>
